import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from 'contexts/ThemeContext';

import { Text } from 'components/DataDisplay';
import { Modal } from 'components/Feedback';
import { FormSection } from 'components/FormSection';
import { Button } from 'components/Inputs';
import { Item, Row } from 'components/Layout';

export const ModalDelete = props => {
  const { onClose, onDelete, name, type } = props;

  const { themeColors } = useTheme();
  return (
    <Modal maxWidth="xs" {...props}>
      <FormSection title="Suppression de configuration">
        <Row>
          <Item>
            <Text>
              Êtes-vous sûr(e) de vouloir supprimer {type} ?
              <Text bold>{name || ''}</Text>
            </Text>
          </Item>
        </Row>
        <Row justify="space-between">
          <Item xs={4}>
            <Button
              variant="contained"
              size="medium"
              widthSize="medium"
              rounded
              color={themeColors.themeV2.btnGreyBackground}
              fontColor={themeColors.keep_dark}
              onClick={onClose}
            >
              Annuler
            </Button>
          </Item>
          <Item xs={4}>
            <Button
              variant="contained"
              size="medium"
              widthSize="medium"
              rounded
              onClick={onDelete}
            >
              Supprimer
            </Button>
          </Item>
        </Row>
      </FormSection>
    </Modal>
  );
};

ModalDelete.defaultProps = {};
ModalDelete.propTypes = {
  name: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ModalDelete;
